import type { NewsletterContent } from "../types";

/** 邮件订阅条（参考 about.google 的 newsletter signup） */
export function renderNewsletter(nl: NewsletterContent): string {
  return `
    <section class="section newsletter-section" id="${nl.id}">
      <div class="newsletter" data-reveal>
        <div class="newsletter-text">
          <h2>${nl.title}</h2>
          <p>${nl.intro}</p>
        </div>
        <form class="newsletter-form" novalidate>
          <input type="email" name="email" placeholder="${nl.placeholder}" aria-label="Email" required />
          <button type="submit" class="btn solid">${nl.submit}</button>
          <p class="newsletter-msg" role="status" aria-live="polite"></p>
        </form>
      </div>
    </section>`;
}
